<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.configuracaoRastreabilidade.segmentos.titulo")',
        :voltarPara='{ route: "ConfiguracaoSegmentos" }'
    )
    .bloco-cadastro-segmentos
        h3 {{ $t('mensagens.configuracaoRastreabilidade.segmentos.dadosCadastrais') }}
        .form-cadastro-segmento
            .form-cadastro-segmento__row
                label.form-cadastro-segmento__row-label.obrigatorio {{ $t('mensagens.configuracaoRastreabilidade.segmentos.nome') }}
                input.form-cadastro-segmento__row-input(
                    :placeholder='$t("mensagens.configuracaoRastreabilidade.segmentos.nomePlaceHolder")',
                    v-model='segmento.nome'
                )
            .form-cadastro-segmento__row
                label.form-cadastro-segmento__row-label.obrigatorio {{ $t('mensagens.configuracaoRastreabilidade.segmentos.sigla') }}
                input.form-cadastro-segmento__row-input(
                    :placeholder='$t("mensagens.configuracaoRastreabilidade.segmentos.siglaPlaceHolder")',
                    v-model='segmento.codigo'
                )
        .footer
            .footer__btn.voltar(@click='goToListagemSegmentos')
                i.mdi.mdi-arrow-left
                span {{ $t('mensagens.comuns.voltar') }}
            .footer__btn.salvar(@click='cadastrarSegmento')
                span {{ $t('mensagens.comuns.salvar') }}
                i.mdi.mdi-arrow-right
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import ConfiguracaoSegmentosService from '@/services/ConfiguracaoSegmentosService';

export default {
    name: 'CadastroSegmento',
    components: {
        BaseHeader
    },
    data() {
        return {
            segmento: {
                nome: '',
                codigo: ''
            }
        };
    },
    methods: {
        goToListagemSegmentos() {
            this.$router.push({ name: 'ConfiguracaoSegmentos' });
        },
        async cadastrarSegmento() {
            const inputValido = this.validaInput();
            if (inputValido) {
                try {
                    const payload = this.montarPayload();

                    await ConfiguracaoSegmentosService.cadastrarSegmento(
                        payload
                    )
                        .then(() => {
                            this.$notify.success({
                                message: this.$t(
                                    'mensagens.configuracaoRastreabilidade.segmentos.cadastroEfetuado'
                                )
                            });
                            this.$router.push({
                                name: 'ConfiguracaoSegmentos'
                            });
                        })
                        .catch(e => {
                            this.$notify.error({
                                message: e.response.data.message
                            });
                        });
                } catch (error) {
                    this.$notify.error(error.message);
                }
            }
        },
        validaInput() {
            if (!this.segmento.nome || this.segmento.nome.trim() === '') {
                this.$notify.error(
                    this.$t(
                        'mensagens.configuracaoRastreabilidade.segmentos.validarNome'
                    )
                );
                return false;
            }

            if (!this.segmento.codigo || this.segmento.codigo.trim() === '') {
                this.$notify.error(
                    this.$t(
                        'mensagens.configuracaoRastreabilidade.segmentos.validarCodigo'
                    )
                );
                return false;
            }

            return true;
        },
        montarPayload() {
            return {
                nome: this.segmento.nome,
                codigo: this.segmento.codigo
            };
        }
    }
};
</script>

<style lang="scss">
.bloco-cadastro-segmentos {
    margin: 20px;
}

.form-cadastro-segmento {
    margin-top: 10px;
    background-color: $white;
    padding: 15px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    border-radius: $default-border-radius;
    @include default-box-shadow();
}

.form-cadastro-segmento__row {
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.form-cadastro-segmento__row-label {
    color: $primary;
    font-weight: bold;
}

.obrigatorio::after {
    content: '* ';
    color: red;
    margin-left: 3px;
}

.form-cadastro-segmento__row-input {
    width: 50%;
    height: 40px;
    border-radius: $default-border-radius;
    border: 1px solid $default-border-color;
    outline: 0;
    padding: 0 15px;
}

.form-cadastro-segmento__row-input-area {
    display: flex;
    gap: 10px;
    align-items: center;
}

.form-cadastro-segmento__btn-remover-cpf-cnpj {
    width: 48px;
    height: 32px;
    background-color: $background-danger;
    color: $font-danger;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: $default-border-radius;
}

.form-cadastro-segmento__btn-add-cpf-cnpj {
    width: 210px;
    height: 40px;
    margin-top: 5px;
    background-color: $white;
    color: $primary;
    font-weight: bold;
    border: 1px solid $primary;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 3px;
    border-radius: $default-border-radius;
    cursor: pointer;

    i.el-icon-plus {
        font-weight: bold;
    }
}

.form-cadastro-segmento__btn-add-cpf-cnpj:hover {
    background-color: var(--primary);
    color: $white;
}

.footer {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.footer__btn {
    width: 100px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: $default-border-radius;
    cursor: pointer;

    .mdi-arrow-left {
        color: var(--primary);
    }

    .mdi-arrow-right {
        color: $white;
    }
}

.salvar {
    background-color: var(--primary);
    color: $white;
}

.salvar:hover {
    background-color: var(--secondary);
}

.footer__btn.voltar {
    background-color: transparent;
    color: var(--primary);
    border: 1px solid var(--primary);
}

.footer__btn.voltar:hover {
    background-color: var(--primary);
    color: $white;

    .mdi-arrow-left {
        color: $white;
    }
}
</style>
